import { render, staticRenderFns } from "./ForeignSaleDetails.vue?vue&type=template&id=7082da58&scoped=true"
import script from "./ForeignSaleDetails.vue?vue&type=script&lang=js"
export * from "./ForeignSaleDetails.vue?vue&type=script&lang=js"
import style0 from "./ForeignSaleDetails.vue?vue&type=style&index=0&id=7082da58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7082da58",
  null
  
)

export default component.exports